import React from 'react'
import PropTypes from 'prop-types'
import close_white from 'images/svg/close_white.svg'
import InvestorMenuContentPanel from './InvestorMenuContentPanel'
import InvestorProfile from './InvestorProfile'
import InvestorSavedSearches from './InvestorSavedSearches'
import InvestorNotifications from './InvestorNotifications'
import InvestorChangeImage from './InvestorChangeImage'
import ArrowDropDown from '@material-ui/icons/ArrowDropDown'
import ArrowDropUp from '@material-ui/icons/ArrowDropUp'
import { Hidden, Drawer, Grow, Divider, ClickAwayListener, Paper, Popper, MenuItem, MenuList, withStyles, List } from '@material-ui/core'
import Button from 'components/ButtonMaterial'
import profileImg from 'images/svg/profile.svg'
import InvestorSettings from './InvestorSettings'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import starIcon from 'images/svg/star-icon.svg'
import { TITLES, ROUTES_PATH } from '../../../constants'
import { isUserPremium } from '../../../utils'

const styles = theme => ({
  signIn: {
    color: '#ffffff',
    fontWeight: '400',
    lineHeight: '1.11',
    backgroundColor: '#00bcb5',
    height: '100%',
    width: '100%',
    minWidth: '220px',
    fontSize: '15px',
    [theme.breakpoints.down('xs')]: {
      minWidth: '0',
      marginLeft: '0',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
      justifyContent: 'flex-start',
      paddingLeft: '10px',
    },
    padding: '0',
    borderRadius: '0',
    '&:focus': { backgroundColor: '#00bcb5' },
    '&:hover': { backgroundColor: '#00bcb5' },
  },
  mobileSlideClose: {
    display: 'flex',
    backgroundColor: '#00bcb5',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0px 10px',
    height: '48px',
  },
  slideCloseIcon: {
    width: '28px',
    height: '28px',
  },
  profileImage: {
    [theme.breakpoints.down('sm')]: {
      width: '5%',
      order: '2',
    },
    [theme.breakpoints.down('xs')]: {
      width: '10%',
      '@media (orientation: landscape)': {
        width: '5%',
      },
    },
    width: '17%',
  },
  avartarImage: {
    border: '0px solid #fff',
    borderRadius: '50%',
    [theme.breakpoints.down('sm')]: {
      order: '2',
    },
  },
  userName: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    paddingLeft: '2%',
    [theme.breakpoints.up('md')]: { width: '35%' },
    [theme.breakpoints.down('sm')]: { width: '91%', order: '3' },
    [theme.breakpoints.down('xs')]: { width: '85%' },
  },
  starIconBox: {
    background: `#fff`,
    width: '32px',
    display: 'flex',
    position: 'absolute',
    right: '0',
    top: '17px',
    justifyContent: 'center',
    alignItems: 'center',
    height: '28px',
    borderRadius: '21px 0 0 21px',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      top: '0',
      marginLeft: '-24px',
      marginRight: '15px',
      height: '28px',
      order: '1',
      borderRadius: '0 21px 21px 0',
    },
    '&:before': {
      content: '""',
      width: '16px',
      height: '16px',
      display: 'block',
      backgroundImage: `url(${starIcon})`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '1px 0',
    },
  },
  menuListToggle: {
    width: '100%',
  },
  menuList: {
    paddingBottom: '0',
  },
  menuPaperContainer: {
    borderRadius: '0',
  },
  menuDivider: {},
  mobileMenuItem: {
    fontWeight: '200',
    padding: '15px 20px',
    fontSize: '18px',
    '&active': { color: '#00bcb5' },
    display: 'flex',
    fontFamily: '"Rubik","Helvetica Neue",Arial,sans-serif',
  },
  premiumOption: {
    fontWeight: '500',
    '&:before': {
      backgroundImage: `url(${starIcon})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      content: '""',
      display: 'block',
      margin: '1px 0 0 10px',
      width: '18px',
      order: '2',
      height: '18px',
    },
  },
  mobileMenuLogoutItem: {
    fontWeight: '300',
    textTransform: 'none',
  },
  logoutLink: {
    color: '#838383',
  },
  progress: {
    color: '#00bcb5',
  },
})
const notificationObj = {
  title: TITLES.NOTIFICATIONS,
  onMobileMenu: true,
  onDesktopMenu: true,
}
const menuOptions = {
  savedSearches: {
    title: TITLES.SEARCHES,
    onMobileMenu: true,
    onDesktopMenu: false,
  },
  profile: {
    title: TITLES.PROFILE,
    onMobileMenu: true,
    onDesktopMenu: true,
  },
  settings: {
    title: TITLES.SETTINGS,
    onMobileMenu: true,
    onDesktopMenu: true,
  },
  changeImage: {
    title: TITLES.IMAGE,
    onMobileMenu: false,
    onDesktopMenu: false,
  },
  premium: {
    title: TITLES.PREMIUM,
    onMobileMenu: true,
    onDesktopMenu: true,
  },
}

class InvestorMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menuOpen: false,
      menuContentPanelOpened: false,
      contentPanelSelected: {},
      imageUploaded: null,
    }
  }

  handleToggleMenuContentPanel = () => {
    this.setState(prevState => ({ menuContentPanelOpened: !prevState.menuContentPanelOpened }))
    this.props.onCloseMenu()
  }

  handleToggleMenu = () => this.setState(prevState => ({ menuOpen: !prevState.menuOpen }))

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return
    }
    this.setState({ menuOpen: false })
    this.props.onCloseMenu()
  }

  handleLogOut = () => {
    this.handleToggleMenu()
    this.props.onLogOut()
  }

  handleSelectedOptionContent = menuOption => {
    this.setState({
      contentPanelSelected: menuOption,
      menuContentPanelOpened: true,
    })
  }

  handleImageUpload = image => {
    this.setState({
      imageUploaded: image,
    })
    this.handleSelectedOptionContent(menuOptions.changeImage)
  }

  handleImageChange = () => {
    this.handleSelectedOptionContent(menuOptions.changeImage)
  }

  routeChange() {
    this.props.history.push(ROUTES_PATH.PRICING)
  }

  createMenuOptions(isDesktopView) {
    return [...Object.keys(menuOptions).map(el => menuOptions[el])]
      .filter(option => option.onMobileMenu || option.onDesktopMenu)
      .map(option => {
        const premiumClass = option.title === menuOptions.premium.title ? this.props.classes.premiumOption : ''
        const mobileClasses = `${premiumClass} ${this.props.classes.mobileMenuItem}`
        return isDesktopView && option.onDesktopMenu ? (
          option.title !== TITLES.PREMIUM ? (
            <MenuItem
              key={option.title}
              className={`${premiumClass}`}
              onClick={() => {
                this.handleSelectedOptionContent(option)
              }}>
              {option.title}
            </MenuItem>
          ) : !isUserPremium(this.props.user) && !this.props.hidePremium ? (
            <MenuItem
              key={option.title}
              className={`${premiumClass}`}
              onClick={() => {
                this.routeChange()
              }}>
              {option.title}
            </MenuItem>
          ) : (
            ''
          )
        ) : !isDesktopView && option.onMobileMenu ? (
          option.title !== TITLES.PREMIUM ? (
            <List
              key={option.title}
              className={`${mobileClasses}`}
              onClick={() => {
                this.handleSelectedOptionContent(option)
              }}>
              {option.title}
            </List>
          ) : !isUserPremium(this.props.user) ? (
            <List
              key={option.title}
              className={`${mobileClasses}`}
              onClick={() => {
                this.routeChange()
              }}>
              {option.title}
            </List>
          ) : (
            ''
          )
        ) : (
          ''
        )
      })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.openSavedSearch !== this.props.openSavedSearch) {
      this.setState({
        menuContentPanelOpened: this.props.openSavedSearch,
        contentPanelSelected: menuOptions.savedSearches,
      })
    }
    if (prevProps.notificationSelected !== this.props.notificationSelected && this.props.notificationSelected) {
      this.setState({ menuOpen: true })
      this.handleSelectedOptionContent(notificationObj)
    }
    if (
      prevState.menuContentPanelOpened !== this.state.menuContentPanelOpened &&
      !this.state.menuContentPanelOpened &&
      this.state.contentPanelSelected === menuOptions.settings
    ) {
      if (this.props.setShowSettings) {
        this.props.setShowSettings()
        this.props.history.push('/')
      }
    } else if (
      prevState.menuContentPanelOpened === this.state.menuContentPanelOpened &&
      this.props.location !== undefined &&
      this.props.location.pathname.indexOf('settings') > -1
    ) {
      this.props.setShowSettings()
      this.props.history.push('/')
    }
  }

  componentDidMount() {
    if (this.props.showSettings) {
      this.setState({ menuOpen: true })
      this.handleSelectedOptionContent(menuOptions.settings)
    }
    if (this.props.notificationSelected) {
      this.setState({ menuOpen: true })
      this.handleSelectedOptionContent(notificationObj)
    }
  }

  createSignInBtn(arrow) {
    const { classes, user } = this.props
    const profileClass = this.props.avatarUrl ? `${classes.profileImage} ${classes.avartarImage}` : `${classes.profileImage}`
    const url = this.props.avatarUrl
      ? this.props.avatarUrl.indexOf('homevestors') > -1
        ? `${this.props.avatarUrl}?${new Date().getTime()}`
        : this.props.avatarUrl
      : profileImg
    return !user.isUpdating ? (
      <Button
        className={classes.signIn}
        id={'user_profile'}
        buttonRef={node => {
          this.anchorEl = node
        }}
        aria-owns={this.state.menuOpen ? 'menu-list-grow' : null}
        aria-haspopup="true"
        onClick={this.handleToggleMenu}>
        <img src={url} alt={''} className={profileClass} />
        <span className={classes.userName}>{this.props.firstName}</span>
        {isUserPremium(user) && <span className={classes.starIconBox} />}
        {arrow ? this.state.menuOpen ? <ArrowDropUp /> : <ArrowDropDown /> : ''}
      </Button>
    ) : null
  }

  render() {
    const { classes, onCloseMenu, user, notifications } = this.props

    const { menuOpen, contentPanelSelected, menuContentPanelOpened } = this.state

    let contentPanelContent
    if (this.state.menuContentPanelOpened) {
      switch (contentPanelSelected) {
        case menuOptions.savedSearches: {
          contentPanelContent = <InvestorSavedSearches user={user} closeMenu={onCloseMenu} />
          break
        }
        case menuOptions.profile: {
          contentPanelContent = (
            <InvestorProfile
              user={this.props.user}
              handleClose={this.handleToggleMenuContentPanel}
              onImageChange={this.handleImageChange}
              onImageUpload={this.handleImageUpload}
            />
          )
          break
        }
        case notificationObj: {
          contentPanelContent = (
            <InvestorNotifications user={user} notifications={notifications} markNotificationUnread={() => this.props.markNotificationUnread()} />
          )
          break
        }
        case menuOptions.settings: {
          contentPanelContent = <InvestorSettings user={user} handleClose={this.handleToggleMenuContentPanel} />
          break
        }
        case menuOptions.changeImage: {
          contentPanelContent = (
            <InvestorChangeImage
              imageUploaded={this.state.imageUploaded}
              handleBack={() => this.handleSelectedOptionContent(menuOptions.profile)}
              user={user}
            />
          )
          break
        }
        default: {
        }
      }
    }

    contentPanelContent = (
      <InvestorMenuContentPanel
        user={this.props.user}
        title={this.state.contentPanelSelected.title}
        handleClose={this.handleToggleMenuContentPanel}
        isLoading={user.isUpdating}>
        {contentPanelContent}
      </InvestorMenuContentPanel>
    )

    return (
      <React.Fragment>
        <Hidden smDown>
          {this.createSignInBtn(true)}
          <Popper open={menuOpen} anchorEl={this.anchorEl} transition disablePortal placement="top-end" className={classes.menuListToggle}>
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="menu-list-grow"
                style={{
                  transformOrigin: placement === 'top-end' ? 'center top' : 'center bottom',
                }}>
                <Paper className={classes.menuPaperContainer}>
                  <ClickAwayListener onClickAway={this.handleClose}>
                    <MenuList className={classes.menuList}>
                      {this.createMenuOptions(true)}
                      <Divider light className={classes.menuDivider} />
                      <MenuItem className={classes.logoutLink} onClick={this.handleLogOut}>
                        Logout
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
          {menuContentPanelOpened && (
            <Drawer anchor="right" open={this.state.menuContentPanelOpened} onClose={this.handleToggleMenuContentPanel}>
              {contentPanelContent}
            </Drawer>
          )}
        </Hidden>
        <Hidden mdUp>
          {!menuContentPanelOpened ? (
            <React.Fragment>
              <div className={classes.mobileSlideClose}>
                {this.createSignInBtn(false)}
                <div onClick={onCloseMenu}>
                  <img src={close_white} alt={'close'} className={classes.slideCloseIcon} />
                </div>
              </div>
              {this.createMenuOptions(false)}
              <Divider light />
              <List className={`${classes.mobileMenuItem} ${classes.mobileMenuLogoutItem} ${classes.logoutLink}`} onClick={this.handleLogOut}>
                Logout
              </List>
            </React.Fragment>
          ) : (
            contentPanelContent
          )}
        </Hidden>
      </React.Fragment>
    )
  }
}

InvestorMenu.propTypes = {
  user: PropTypes.object.isRequired,
  onLogOut: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  onCloseMenu: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    user: state.user,
    avatarUrl: state.user.personalData.get('avatarUrl'),
    firstName: state.user.personalData.get('firstName'),
  }
}

const investorMenu = connect(mapStateToProps)(InvestorMenu)
export default withStyles(styles)(withRouter(investorMenu))



// WEBPACK FOOTER //
// ./src/features/investorDashboard/components/InvestorMenu.js